(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.hasRol=hasRol;
        vm.rolesUsuario=rolesUsuario;
        
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
        function hasRol () {
        	var has=false;
        	if(vm.account!=null && vm.account.authorities!=null){
        		 for(var i=0;i<vm.account.authorities.length;i++){
        			 if(vm.account.authorities[i]=='PROFESOR'){
        				 has=true; 
        			 }
        			 if(vm.account.authorities[i]=='RESPONSABLE_SIDE'){
        				 has=true;}
        			 if(vm.account.authorities[i]=='ALUMNO'){
        				 has=true;}
        			 if(vm.account.authorities[i]=='ADMINISTRATIVO_GENERAL_SIDE'){
        				 has=true;}
				     if(vm.account.authorities[i]=='ADMINISTRATIVO_BACHILLERATO_SIDE'){
						 has=true;}
        		 }
        	}
            return has;
        }
        
        function rolesUsuario () {
        	
        	var roles = [];
//        	console.log(vm.account.authorities);
        	if(vm.account!=null && vm.account.authorities!=null){
        		 for(var i=0;i<vm.account.authorities.length;i++){
        			 if(vm.account.authorities[i]=='PROFESOR'){
        				 roles.push("PROFESOR");}
        			 if(vm.account.authorities[i]=='RESPONSABLE_SIDE'){
        				 roles.push("RESPONSABLE_SIDE");}
        			 if(vm.account.authorities[i]=='ALUMNO'){
        				 roles.push("ALUMNO");}
        			 if(vm.account.authorities[i]=='ADMINISTRATIVO_GENERAL_SIDE'){
        				 roles.push("ADMINISTRATIVO_GENERAL_SIDE");}
					if(vm.account.authorities[i]=='ADMINISTRATIVO_BACHILLERATO_SIDE'){
						 roles.push("ADMINISTRATIVO_BACHILLERATO_SIDE");}
        		 }
        	}
            return roles;
        }
    }
})();
